import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { auth } from '../../../services/auth.service';

export const GET_REGIONS = 'GET_REGIONS';
export const ADD_REGION = 'ADD_REGION';
export const GET_DISTRICTS_FOR_REGION = 'GET_DISTRICTS_FOR_REGION';
export const DELETE_REGION = 'DELETE_REGION';
export const UPDATE_REGION = 'UPDATE_REGION';

const successColor = 'success';
const errorColor = 'danger';
const warningColor = 'warning';

export function fetchRegions() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageRegions/GetRegions`, { headers: auth.authHeader() })
			.then((response) => {
				// console.log('see here........', response);
				dispatch({
					type: GET_REGIONS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function getDistricts() {
	return function(dispatch) {
		axios
			.get(`${ROOT_API_URL}/ManageRegions/GetDistrictsForRegion`, { headers: auth.authHeader() })
			.then((response) => {
				// console.log('getdistricts for region', response);
				dispatch({
					type: GET_DISTRICTS_FOR_REGION,
					payload: response.data
				});
			})
			.catch((response) => {
				console.log(response);
			});
	};
}

export function addRegion(model) {
	// console.log('to see action creator received: ', model);
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageRegions/CreateRegion`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: ADD_REGION,
						payload: response.data.regions
					});
					var success = response && response.data ? response.data.message : 'User Created Successfully';
					dispatch(toastr(true, success, successColor));
				} else {
					var err = response && response.data ? response.data.message : 'User Already Exists';
					dispatch(toastr(true, err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function deleteRegion(model) {
	return function(dispatch) {
		axios
			.post(`${ROOT_API_URL}/ss/DeleteRegion`, model, { headers: auth.authHeader() })
			.then((response) =>
				dispatch({
					type: DELETE_REGION,
					payload: response.data
				})
			)
			.catch((response) => {
				console.log(response);
			});
	};
}

export function updateRegion(model) {
	console.log('action creator to see what you recived: ', model);
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageRegions/UpdateRegion`, model, { headers: auth.authHeader() })
			.then((response) => {
				console.log('update response', response);
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: UPDATE_REGION,
						payload: response.data.regions
					});
					var success = response && response.data ? response.data.message : 'Region Updated Successfully';
					dispatch(toastr(true, success, successColor));
				} else {
					var err = response && response.data ? response.data.message : 'Error Occured';
					dispatch(toastr(true, err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(toastr(true, err, errorColor));
			});
	};
}
